import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_2 = {
  class: "d-flex align-items-center justify-content-center",
  style: {"min-height":"600px"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "w-100 card verify-card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_5 = { class: "mx-auto w-250px h-300px shadow-sm d-flex flex-column justify-content-center align-items-center gap-5 p-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/success.png",
  alt: "",
  class: "w-75"
}, null, -1)
const _hoisted_7 = { style: {"color":"#bbe285","font-size":"32px"} }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_10 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_11 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_12 = {
  key: 1,
  class: "indicator-label"
}
const _hoisted_13 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_14 = { class: "indicator-progress" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

import { ref, provide, onMounted, reactive, inject } from "vue";
import ProductsAgreement from "./ProductsAgreement.vue";
import ProductInfo from "../../verification/components/jp/VerificationInfoJp.vue";
import ProductFinancial from "./ProductFinancial.vue";
import ProductReview from "./ProductReview.vue";
import ProductPending from "./ProductPending.vue";
import VerificationService from "@/projects/client/modules/verification/services/VerificationService";
import type { FormInstance } from "element-plus";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { isMobile } from "@/core/config/WindowConfig";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { useI18n } from "vue-i18n";
import { getItemByValue } from "@/core/helpers/helpers";
import { accountTypesSelection } from "@/core/types/jp/verificationFinancial";
import { VerificationStatusTypes } from "@/core/types/VerificationInfos";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductRegister',
  setup(__props) {

const { t } = useI18n();
const isSubmitting = ref(false);
const currentStepIndex = ref<any>(0);
const totalSteps = ref(2);
const items = ref<any>([]);
const ruleFormRef = ref<FormInstance>();
const formData = ref<any>({});
const isLoading = ref(false);
const submitButton = ref<HTMLButtonElement | null>(null);
const selectedAccountTypes = inject<any>("selectedAccountTypes");
const selectedVerification = inject<any>("selectedVerification");
const verificationData = inject<any>("verificationData");

provide("formData", formData);
provide("currentStepIndex", currentStepIndex);
provide("totalSteps", totalSteps);
provide("items", items);
provide("isSubmitting", isSubmitting);

const submit = async (e) => {
  e.preventDefault();
  if (!ruleFormRef.value) return;
  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) return;
  if (submitButton.value) {
    submitButton.value!.disabled = true;
    submitButton.value.setAttribute("data-kt-indicator", "on");
  }
  isSubmitting.value = true;
  try {
    switch (currentStepIndex.value) {
      case 1:
        await handleInfo();
        break;
      case 2:
        await handleFinancial();
        break;
      case 3:
        await handleAgreement();
        break;
      case 4:
        await submitVerification();
        break;
    }
    if (currentStepIndex.value != 4) {
      currentStepIndex.value = 4;
    } else {
      currentStepIndex.value = 5;
    }

    window.scrollTo(0, 0);
  } catch (error: any) {
    console.error(error);
    MsgPrompt.error(error);
  }

  if (submitButton.value) {
    submitButton.value.disabled = false;
    submitButton.value.removeAttribute("data-kt-indicator");
  }
  isSubmitting.value = false;
};

const handleInfo = async () => {
  items.value.data.info = formData.value;
};

const handleFinancial = async () => {
  items.value.data.financial = formData.value;
};

const handleAgreement = async () => {
  items.value.data.agreement = formData.value;
  items.value.data.financial.accountRole = formData.value.accountRole;
};

const submitVerification = async () => {
  await VerificationService.submitNewVerification();
  await saveNewVerificationData();
  items.value.status = 1;
};

const saveNewVerificationData = async () => {
  await Promise.all([
    // saveStarted(),
    saveInfo(),
    saveFinancial(),
    saveAgreement(),
  ]);

  await saveVerification().then(() => {
    MsgPrompt.success(t("status.success"));
  });
};

const saveStarted = async () => {
  const startedFormData = new FormData();
  var started = items.value.data.started;
  var platform = formData.value.serviceId == 30 ? 30 : 20;

  for (const [key, value] of Object.entries(started)) {
    startedFormData.append(key, value);
  }
  startedFormData.append("platform", platform);
  // await VerificationService.postVerificationStarted(formData.value);
};

const saveInfo = async () => {
  var info = items.value.data.info;
  await VerificationService.postVerificationInfo(info);
};

const saveFinancial = async () => {
  var financial = items.value.data.financial;
  await VerificationService.postVerificationFinancial(financial);
};

const saveAgreement = async () => {
  var agreement = items.value.data.agreement;
  await VerificationService.postVerificationAgreement(agreement);
};

const saveVerification = async () => {
  await VerificationService.submitVerification();
};

// const fetchData = async () => {
//   isLoading.value = true;

//   try {
//     const verificationRes =
//       await VerificationService.getExistingVerifications();

//     const { info, financial, agreement, ...restVerification } =
//       verificationRes.at(-1);

//     const data = {
//       data: {
//         info,
//         financial,
//         agreement,
//       },
//       ...restVerification,
//     };

//     items.value = data;
//     items.value.status = 0;
//     steps.value = 3;
//     totalSteps.value = 5;
//     await processAccTypes();
//     currentStepIndex.value = 3;
//   } catch (error: any) {
//     console.error(error);
//   }

//   isLoading.value = false;
// };

const fetchData = async () => {
  isLoading.value = true;

  try {
    let info, financial, agreement, restVerification;
    if (selectedVerification.value == null) {
      const lastVerification = verificationData.value.at(-1);
      lastVerification.status = 0;
      lastVerification.financial.accountTypes = selectedAccountTypes.value;
      ({ info, financial, agreement, ...restVerification } = lastVerification);
      currentStepIndex.value = 3;
    } else {
      verificationData.value.forEach((item) => {
        console.log("item", item.financial.accountTypes);
        console.log(
          "selectedVerification",
          selectedVerification.value.accountTypes
        );
        if (
          item.financial.accountTypes.includes(
            selectedVerification.value.verificationAccType
          )
        ) {
          ({ info, financial, agreement, ...restVerification } = item);
        }
      });
    }

    const data = {
      data: {
        info,
        financial,
        agreement,
      },
      ...restVerification,
    };

    items.value = data;
    console.log("items", items.value);
    totalSteps.value = 5;
  } catch (error: any) {
    console.error(error);
  }

  isLoading.value = false;
};

const processAccTypes = async () => {
  items.value.data.financial.accountTypes = selectedAccountTypes.value;
};

const previousStep = () => {
  if (currentStepIndex.value > 0) {
    currentStepIndex.value--;
    window.scrollTo(0, 0);
  }
};

const rules = reactive<any>({
  // Started
  leverage: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  accountType: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  // Info
  firstName: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "blur" },
  ],
  lastName: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "blur" },
  ],
  nativeNameLast: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "blur" },
  ],
  nativeNameFirst: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "blur" },
  ],
  gender: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  birthday: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  postalCode: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  region: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  village: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  town: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  street: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  buildingNumber: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],

  email: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "blur" },
    { type: "email", message: t("tip.invalidEmail"), trigger: "blur" },
  ],
  phone: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "blur" },
  ],
  occupation: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  companyName: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  companyPhone: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  citizen: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  otherCitizen: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  countryOfResidence: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  usTax: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  declarationRegardingForeignPeps: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  otherPeps: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  // Financial
  accountRole: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  accountTypes: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  investorDistinction: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  annualIncome: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  investment: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  investmentFunds: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  mainIncomeSource: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  transactionMotive: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  assetManagementPeriod: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  mainFund: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  fx: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  stockTradingSpot: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  stockTradingCredit: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  indexOption: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  commodityFuturesTrading: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  otherDerivativesTransaction: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  investmentPurpose: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  financialInstiutionName: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  financialInstiutionType: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  branchName: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  accountNumber: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  depositType: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  accountHolderFullWidth: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  accountHolderFullWidthKatakana: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  // Agreement
  check_1: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  check_2: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  check_3: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  check_4: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  check_5: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  check_6: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  check_7: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  check_8: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  check_9: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  check_10: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
  check_11: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "change" },
  ],
});

onMounted(async () => {
  await fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ScaleLoader, { color: '#ffc730' })
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          class: _normalizeClass(["pb-10", {
        'mt-5 ': currentStepIndex.value !== 5,
      }]),
          model: formData.value,
          rules: rules,
          "hide-required-asterisk": true,
          "label-width": "auto",
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            (
          items.value.status == _unref(VerificationStatusTypes).Approved ||
          items.value.status == _unref(VerificationStatusTypes).CodeVerified ||
          items.value.status == _unref(VerificationStatusTypes).Rejected
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t("status.success") + "!"), 1),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("tip.verificationFinishedWaitApproval")), 1)
                  ])
                ]))
              : (items.value.status != _unref(VerificationStatusTypes).Incomplete)
                ? (_openBlock(), _createBlock(ProductPending, { key: 1 }))
                : (currentStepIndex.value == 1)
                  ? (_openBlock(), _createBlock(ProductInfo, { key: 2 }))
                  : (currentStepIndex.value == 2)
                    ? (_openBlock(), _createBlock(ProductFinancial, { key: 3 }))
                    : (currentStepIndex.value == 3)
                      ? (_openBlock(), _createBlock(ProductsAgreement, { key: 4 }))
                      : (currentStepIndex.value == 4)
                        ? (_openBlock(), _createBlock(ProductReview, { key: 5 }))
                        : _createCommentVNode("", true),
            (
          currentStepIndex.value < totalSteps.value &&
          items.value.status == _unref(VerificationStatusTypes).Incomplete
        )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 6,
                  class: _normalizeClass(["d-flex mt-5", {
          'justify-content-center gap-5': _unref(isMobile),
          'justify-content-end': !_unref(isMobile),
        }])
                }, [
                  (currentStepIndex.value == 4)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-lg btn-light-primary me-3",
                        onClick: previousStep
                      }, [
                        _createElementVNode("span", _hoisted_9, [
                          _createVNode(_component_inline_svg, { src: "/images/icons/arrows/arr063.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("action.back")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-lg btn-primary me-3",
                    ref_key: "submitButton",
                    ref: submitButton,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (submit($event)))
                  }, [
                    (currentStepIndex.value === totalSteps.value - 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _createTextVNode(_toDisplayString(_ctx.$t("action.submit")) + " ", 1),
                          _createElementVNode("span", _hoisted_11, [
                            _createVNode(_component_inline_svg, { src: "/images/icons/arrows/arr064.svg" })
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createTextVNode(_toDisplayString(_ctx.$t("action.next")) + " ", 1),
                          _createElementVNode("span", _hoisted_13, [
                            _createVNode(_component_inline_svg, { src: "/images/icons/arrows/arr064.svg" })
                          ])
                        ])),
                    _createElementVNode("span", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.$t("action.pleaseWait")) + " ", 1),
                      _hoisted_15
                    ])
                  ], 512)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class", "model", "rules"])
      ]))
}
}

})